<template>
  <div class="drawer drawer--open-left js-drawer text-sm" :id="'drawer-' + index">
    <div class="drawer__content bg-light inner-glow shadow-md flex flex-column" role="alertdialog" aria-labelledby="drawer-title42">
      <header class="flex items-center justify-between flex-shrink-0 border-bottom border-contrast-lower padding-x-sm padding-y-xs">
        <h1 id="drawer-title-2" class="text-xl text-truncate">{{ group.name }}</h1>

        <button class="reset drawer__close-btn js-drawer__close js-tab-focus">
          <svg class="icon icon--xs" viewBox="0 0 16 16"><title>{{ $t('close_drawer') }}</title><g stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"><line x1="13.5" y1="2.5" x2="2.5" y2="13.5"></line><line x1="2.5" y1="2.5" x2="13.5" y2="13.5"></line></g></svg>
        </button>
      </header>

      <div class="drawer__body padding-sm js-drawer__body">
        <div class="text-component">
          <div v-html="group.description"></div>

          <div class="cookies-provider" v-for="(cookie, index) in group.cookies" v-bind:key="index">
            <h4>{{ cookie.provider }}</h4>
            <small><a :href="cookie.more" target="_blank">{{ $t('read_more') }}</a> <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12"><g stroke-width="1" fill="none" stroke="#212121" stroke-linecap="round" stroke-linejoin="round"><polyline points="3.5 3.5 8.5 3.5 8.5 8.5" stroke="#212121"></polyline><line x1="8.5" y1="3.5" x2="0.5" y2="11.5" stroke="#212121"></line><path d="M4.5,11.5H10A1.5,1.5,0,0,0,11.5,10V2A1.5,1.5,0,0,0,10,.5H3A1.5,1.5,0,0,0,1.5,2V5.5"></path></g></svg></small>

            <table v-for="(item, index) in cookie.list" v-bind:key="index" class="prop-table prop-table--v2 width-100%" aria-label="Cookies' Details">
              <tbody class="prop-table__body">
                <tr class="prop-table__row">
                  <th class="prop-table__cell prop-table__cell--th">{{ $t('identification') }}</th>
                  <td class="prop-table__cell">{{ item.name }}</td>
                </tr>

                <tr class="prop-table__row">
                  <th class="prop-table__cell prop-table__cell--th">{{ $t('description') }}</th>
                  <td class="prop-table__cell">{{ item.description }}</td>
                </tr>

                <tr class="prop-table__row">
                  <th class="prop-table__cell prop-table__cell--th">{{ $t('expiration') }}</th>
                  <td class="prop-table__cell">{{ item.expiration }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConsentSettings',
  props: [ 'group', 'index' ]
}
</script>

<style lang="scss">
.cookies-provider {
  margin: 2em 0;
}
</style>